import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import {dataLayerPush} from "@/Helpers/Function";
import reachGoalVkAds from "@/Helpers/ReachGoalVkAds";

export function trackAddToBasket({data, price, count, productId}) {
    reachGoalYM('add_basket');
    reachGoalGA('add_basket');

    const products = data.products.map(el => ({
        ...el,
        count,
        price,
    }));

    dataLayerPush('add_to_cart', 'catalog', 'addToCart', 'product', '', products);

    reachGoalVkAds('addToCart', price, productId);
}
